import {DeclarativeMutationConfig, graphql} from 'react-relay';
import {Disposable, Environment} from 'relay-runtime';
import Util from '../forecast-app/shared/util/util';
import {trackAndCommitMutation} from '../tracking/amplitude/TrackMutation';
import {DeleteProjectStageMutation, DeleteProjectStageMutation$data} from './__generated__/DeleteProjectStageMutation.graphql';

type DeleteProjectStageInput = {
	/** The company's Relay id; the stage is removed from its projectStages connection. */
	companyId: string;
	id: string;
	/** Sent after the admin was warned the stage is the last with its profile. */
	allowLastWithProfile?: boolean;
	/** The stage the stage's projects move to before it is deleted. */
	moveProjectsTo?: string;
};

const mutation = graphql`
	mutation DeleteProjectStageMutation($input: DeleteProjectStageInput!) {
		deleteProjectStage(input: $input) {
			deletedProjectStageId
		}
	}
`;

function getConfigs(input: DeleteProjectStageInput): DeclarativeMutationConfig[] {
	return [
		{
			type: 'RANGE_DELETE',
			parentID: input.companyId,
			connectionKeys: [{key: 'Company_projectStages'}],
			pathToConnection: ['company', 'projectStages'],
			deletedIDFieldName: 'deletedProjectStageId',
		},
		{
			type: 'NODE_DELETE',
			deletedIDFieldName: 'deletedProjectStageId',
		},
	];
}

function commit(
	environment: Environment,
	input: DeleteProjectStageInput,
	onSuccess?: (response: DeleteProjectStageMutation$data) => void,
	onError?: (error: Error) => void
): Disposable {
	return trackAndCommitMutation<DeleteProjectStageMutation>(environment, {
		mutation,
		variables: {
			input: {
				csrfToken: Util.getCsrfValue(),
				socketClientId: Util.getClientId(),
				id: input.id,
				// Only sent when true: during a rolling deploy an instance on the previous release rejects the field.
				...(input.allowLastWithProfile ? {allowLastWithProfile: true} : {}),
				// Only sent when set: during a rolling deploy an instance on the previous release rejects the field.
				...(input.moveProjectsTo ? {moveProjectsTo: input.moveProjectsTo} : {}),
			},
		},
		configs: getConfigs(input),
		onCompleted: onSuccess,
		onError,
	});
}

export default {commit};
